function transformAcceptLanguage(acceptLanguage: string | null): string {
  if (!acceptLanguage) {
    return 'en';
  }

  if (acceptLanguage.includes('_')) {
    return `${acceptLanguage}, ${acceptLanguage.split('_')[0]}`;
  }

  return acceptLanguage;
}

/**
 * Builds an `Accept-Language` header value from the browser's preferred language,
 * normalising e.g. `en-GB` → `en_GB, en`.
 */
export function getAcceptLanguage(): string {
  const rawLanguage = navigator.languages?.[0] || navigator.language || null;
  const normalisedLanguage = rawLanguage ? rawLanguage.replace('-', '_') : null;
  return transformAcceptLanguage(normalisedLanguage);
}
